import ClickToggle from '../../commons/js/utils/ClickToggle';
import AmountRequestForm from './components/AmountRequestForm'
import SimulatorLoader from './components/SimulatorLoader/SimulatorLoader';
import HowItWorksCarouselLoader from './components/HowItWorksCarouselLoader';
import OurCustomersCarouselLoader from './components/OurCustomersCarouselLoader';
import FooterDropDown from '../../commons/js/components/FooterDropDown';
import TrustpilotLazyLoad from '../../commons/js/components/lazy-load/TrustpilotLazyLoad';
import ImgLazyLoad from '../../commons/js/components/lazy-load/ImgLazyLoad';
import PictureLazyLoad from '../../commons/js/components/lazy-load/PictureLazyLoad';
import DefaultHeader from '../../commons/js/components/DefaultHeader';

new DefaultHeader('white')
window.addEventListener('load', () => {
	ClickToggle();
	HowItWorksCarouselLoader();
	SimulatorLoader();
	OurCustomersCarouselLoader();
	FooterDropDown().render();

	new AmountRequestForm().initialize();
	new TrustpilotLazyLoad().initialize();
	new ImgLazyLoad().initialize();
	new PictureLazyLoad().initialize();
});
